module.exports = __webpack_public_path__ + "../resources/images/newestBottomLarge-88db78f874266a563e6abf6cde7418f8.svg";